export default __webpack_public_path__ + "static/media/reparatie_wal.770df9ea.svg";